import React, { useEffect, useState } from "react";
import {
  ArrowPosition,
  IconButton,
  Icons,
  PopupPosition,
  RelativePopupWrapper,
  Text,
  Tooltip,
  useToggle,
} from "@pushpress/shared-components";
import styles from "./SearchEmitter.module.scss";
import useIsMobile from "../../hooks/useIsMobile";

enum OperatingSys {
  Mac = "Mac",
  Windows = "Windows",
}

function SearchEmitter() {
  const [device, setDevice] = useState<OperatingSys>(OperatingSys.Mac);
  const [tooltipVisible, tooltipActions] = useToggle(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes("Win")) {
      setDevice(OperatingSys.Windows);
    }
  }, []);

  const emitCustomEvent = () => {
    const event = new CustomEvent("PageSearch");
    window.dispatchEvent(event);
  };

  const tooltipCommands = device === OperatingSys.Mac ? "⌘ + K" : "Ctrl + K";
  const tooltipComponent = !isMobile ? (
    <Tooltip
      text={`Search and quickly jump to a page ${tooltipCommands}`}
      arrowPosition={ArrowPosition.Right}
    />
  ) : (
    <></>
  );

  return (
    <RelativePopupWrapper
      popupComponent={tooltipComponent}
      popupVisible={tooltipVisible}
      popupPosition={PopupPosition.Center_Left}
      setPopupVisibility={tooltipActions.set}
    >
      <div
        className={styles.container}
        onMouseEnter={tooltipActions.on}
        onMouseLeave={tooltipActions.off}
      >
        <button className={styles.root} onClick={emitCustomEvent}>
          <IconButton
            className={styles.icon}
            icon={Icons.Search}
            size={isMobile ? 18 : 22}
          />
          <div className={styles.text}>
            <Text variant={isMobile ? "body-lg" : "heading-5"} color="wolf-600">
              Search
            </Text>
          </div>
        </button>
      </div>
    </RelativePopupWrapper>
  );
}

export default SearchEmitter;
